// removeLivestreamPinnedMessage.js
'use strict';
import fetch from '../resource/customFetch.js';
import getMeData from '../selector/getMeData.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import handleFetchError from '../resource/handleFetchError.js';

import {
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_ERROR,
  SET_NETWORKING_SUCCESS,
  SET_LIVE_STREAM_DATA,
} from '../ActionTypes.js';

/**
 * Remove livestream pinned message
 * @kind action
 * @param {string} {streamId} - streamId
 * @return {Promise} Action promise.
 */
const removeLivestreamPinnedMessage =
  ({ streamId }) =>
  async (dispatch, getState) => {
    const networkingSelectPath = ['liveStream', streamId, 'chat'];
    const token = getMeData(getState(), 'token');

    if (!token) return dispatch({ type: '' });

    const fetchOptions = {
      method: 'POST',
      headers: {
        ...getHeaders(),
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify([
        {
          text: '',
          pinned: true,
        },
      ]),
    };

    const url = getResourceUrl({ endpoint: `/streams/${streamId}/chat` });

    dispatch({
      type: SET_NETWORKING_FETCHING,
      payload: { selectPath: networkingSelectPath },
    });

    try {
      let response = await fetch(url.href, fetchOptions);

      if (!response.ok) {
        response = await handleFetchError({
          response,
          dispatch,
          getState,
          fetchOptions,
          fetchUrl: url,
        });
      }
      dispatch({
        type: SET_LIVE_STREAM_DATA,
        payload: {
          selectPath: [streamId, 'pinned'],
          data: [],
        },
      });
      return dispatch({
        type: SET_NETWORKING_SUCCESS,
        payload: { selectPath: networkingSelectPath },
      });
    } catch (error) {
      let errorObject = {};
      try {
        errorObject = JSON.parse(error.message);
        errorObject.code = errorObject.code?.toLowerCase?.();
        // eslint-disable-next-line no-empty
      } catch (_) {}

      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { selectPath: networkingSelectPath, error },
      });
    }
  };

export default removeLivestreamPinnedMessage;
